import { Button, Card, InputField, Notice, useToast } from '@laura/design-system';
import { useState } from 'react';
import { authErrorMessage } from './screens.js';
import { useSession } from './session.js';

/**
 * Sign-in and security card, shared by My profile (clinic) and My account
 * (Novations): change password and sign out of every device (plan 03 §5.2, §5.3).
 */
export function SecurityCard({ mfaNote }: { mfaNote: string }) {
  const { backend, signOut } = useSession();
  const toast = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const change = async () => {
    setBusy(true);
    setError('');
    try {
      await backend.changePassword(current, next);
      setCurrent('');
      setNext('');
      toast('Password changed. Use the new one next time you sign in.');
    } catch (e) {
      setError(authErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card title="Sign-in and security">
      <p className="help">{mfaNote}</p>
      {error && <Notice kind="warn">{error}</Notice>}
      <InputField
        label="Current password"
        type="password"
        autoComplete="current-password"
        value={current}
        onChange={(e) => setCurrent(e.target.value)}
      />
      <InputField
        label="New password"
        type="password"
        autoComplete="new-password"
        help="At least 12 characters, with upper and lower case letters, a number and a symbol."
        value={next}
        onChange={(e) => setNext(e.target.value)}
      />
      <div className="row mt-16">
        <Button variant="brand" disabled={busy || !current || !next} onClick={() => void change()}>
          Change password
        </Button>
        <Button onClick={() => void signOut(true)}>Sign out of every device</Button>
      </div>
    </Card>
  );
}
